import { useInfiniteQuery } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { formatEvaluationsListResponse } from '../transformers';
import { IFetchEvaluationListParams } from '../../../types';

/**
 * This is to track the device categories from the backend.
 */
export const EVALUATIONS_LIST_KEY = 'evaluations-list-query';

interface IEvaluationsListQuery {
  cacheTime?: number;
  enabled?: boolean;
  queryParams: IFetchEvaluationListParams;
  staleTime?: number;
}

/**
 * This hook fetches list of evaluations list.
 */
export const useEvaluationsListQuery = ({
  cacheTime,
  enabled,
  queryParams,
  staleTime,
}: IEvaluationsListQuery) => {
  const { page, count, status, search } = queryParams;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // cacheTime
    // staleTime
    staleTime: cacheTime, // TODO: Revise this since cacheTime is no present
    gcTime: staleTime, // TODO: @divyansh also revisit this prop
    enabled,
    queryKey: [EVALUATIONS_LIST_KEY, status, page, count, search],
    networkMode: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      INBOUND_API.fetchEvaluationList({ ...queryParams, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * count;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
    select: formatEvaluationsListResponse,
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetchEvaluationsList: refetch,
  };
};
